import React, { ReactNode, useContext } from 'react';
import classNames from 'classnames';

import { DisplayStyles } from './display-styles';
import { FormContext } from './FormContext';
import { ValidationError } from './validation-error';

export interface IFormErrors {
  [key: string]: ValidationError;
}

interface IProps {
  children: ReactNode | ReactNode[];
  displayStyle?: DisplayStyles;
  hidden?: boolean;
  disabled?: boolean;
  readonly?: boolean;
}

function Form({ children, displayStyle, hidden = false, disabled = false, readonly = false }: IProps) {
  const context = useContext(FormContext);
  const className = classNames('novoForm', {
    'novoForm--inline': displayStyle === DisplayStyles.Inline,
    'novoForm--hidden': hidden,
    'novoForm--readonly': readonly,
  });

  context.disabled = disabled || readonly;
  return (
    <form className={className} onSubmit={context.formik.handleSubmit} noValidate>
      {children}
    </form>
  );
}

export default Form;
